'use client';
import Image from 'next/image';
import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import KEY from '@/components/common/keylist';

const ContactInfo = () => {
    const dynamicTexts = [
        'Building secure, scalable digital solutions that transform operations and accelerate growth.',
        'Turning business challenges into scalable digital products that drive growth.',
        'Partnering with leaders to build technology that delivers measurable results.',
        'Helping companies move from vision to successful product launches.',
        'Delivering software that solves real business problems and scales with demand.',
        'Building digital solutions that accelerate your business and revenue goals.',
        'Modernizing systems and engineering solutions built for enterprise scale.',
        'Empowering your organization with secure, scalable software ecosystems.',
        'Driving transformation with custom software engineered for long-term impact.',
        'From legacy upgrade to AI adoption - we build what keeps businesses competitive.',
        'Enabling smart, future-ready operations with custom enterprise technology.',
        'Turning complex data and AI into competitive advantage for your business.',
        'Engineering AI-powered products that automate, predict, and scale.',
        'Helping businesses adopt AI with practical solutions that deliver outcomes.',
        'Building intelligent digital products that reduce cost and increase efficiency.',
        'Accelerating innovation with AI-driven automation and actionable insights.',
        'Bringing your product vision to market faster with predictable execution.',
        'Scaling your MVP into a high-performing product with real adoption.',
        'Your product roadmap, delivered with precision and speed.',
        'From seed to scale - we build the technology behind fast-growing startups.',
        'Delivering results that help startups grow, raise, and win in the market.',
    ];

    const [currentText, setCurrentText] = useState(dynamicTexts[0]);

    useEffect(() => {
        // Get a random index from the array
        const randomIndex = Math.floor(Math.random() * dynamicTexts.length);
        setCurrentText(dynamicTexts[randomIndex]);
    }, []);

    return (
        <>
            <div className="md:col-span-5 lg:col-span-5">
                <div
                    className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid dark:text-light rounded-lg py-10 px-35  text-center mb-10"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={200}
                >
                    <Image
                        alt="Jaiinam Shahh"
                        src="/img/img-jainam-shah-2x.webp"
                        height="200"
                        width="200"
                        className="mb-5 mx-auto"
                        loading="lazy"
                    />
                    <p className="mb-2.5  text-blue fs-xl font-bold">Jaiinam Shahh</p>
                    <p className="text-secondary dark:text-light">{currentText}</p>
                </div>
                <div
                    className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid rounded-lg lg:py-6 px-5 md:px-5 lg:px-35 experience-section relative overflow-hidden"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                >
                    <div className="rating-section relative z-10 py-6 lg:py-0">
                        <KEY text="AI Enablement for Enterprises & SMEs" className="text-textcolor dark:text-white" />
                        <KEY text="Expertise in Complex Enterprise Software" className="text-textcolor" />
                        <KEY text="Strong Product Engineering Capabilities" className="text-textcolor" />
                        <KEY text="18 Years of Proven Delivery Experience " className="text-textcolor" />
                        <KEY text="900+ Projects Delivered " className="text-textcolor" />
                        <KEY text="ISO 27001:2022 Certified" className="text-textcolor" />
                        <KEY text="CMMI Level 3 Compliant" className="text-textcolor" />
                    </div>
                    <div className="lg:absolute mx:auto text-center rating-img bottom-[-1px] right-[-2px] z-0 lg:w-[42%]">
                        <Image
                            alt="rating star"
                            src="/img/rating-img.webp"
                            height="130"
                            width="130"
                            loading="lazy"
                            data-aos="fade-left"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactInfo;
